<div id="content" class="allcp-form" ng-controller="NotificationController" ng-init="notifications()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="panel-body">
		<div class="table-responsive" ng-if="data.notifications.data.length > 0">
			<table class="table table-hover tc-checkbox-1 fs13">
				<thead>
				<tr class="bg-light">
					<th class="text-left">
						Kargo No
						<a ng-click="sort('id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
							<i class="fa fa-sort-alpha-desc"></i>
						</a>
						<a ng-click="sort('id','asc')" ng-if="filterData.sort == 'desc'">
							<i class="fa fa-sort-alpha-asc"></i>
						</a>
					</th>
					<th>
						İşlem Yapan
						<a ng-click="sort('user_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
							<i class="fa fa-sort-alpha-desc"></i>
						</a>
						<a ng-click="sort('user_id','asc')" ng-if="filterData.sort == 'desc'">
							<i class="fa fa-sort-alpha-asc"></i>
						</a>
					</th>
					<th>
						Bildirim Türü
						<a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
							<i class="fa fa-sort-alpha-desc"></i>
						</a>
						<a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
							<i class="fa fa-sort-alpha-asc"></i>
						</a>
					</th>
					<th>
						Açıklama
						<a ng-click="sort('reason','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
							<i class="fa fa-sort-alpha-desc"></i>
						</a>
						<a ng-click="sort('reason','asc')" ng-if="filterData.sort == 'desc'">
							<i class="fa fa-sort-alpha-asc"></i>
						</a>
					</th>
					<th>
						Personel
						<a ng-click="sort('worker_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
							<i class="fa fa-sort-alpha-desc"></i>
						</a>
						<a ng-click="sort('worker_id','asc')" ng-if="filterData.sort == 'desc'">
							<i class="fa fa-sort-alpha-asc"></i>
						</a>
					</th>
					<th>
						Tarihi
						<a ng-click="sort('scheduled_time','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
							<i class="fa fa-sort-alpha-desc"></i>
						</a>
						<a ng-click="sort('scheduled_time','asc')" ng-if="filterData.sort == 'desc'">
							<i class="fa fa-sort-alpha-asc"></i>
						</a>
					</th>
				</tr>
				</thead>
				<tbody>
				<tr
						dir-paginate="item in data.notifications.data | itemsPerPage: 30"
						total-items="data.notifications.total"
						current-page="data.notifications.current_page">
					<td class="clickable-row" ng-click="getOrderDetails(item.order_id)">#{{item.order_id}}</td>
					<td class="clickable-row">{{ item.user.full_name }} </td>
					<td>
						<span ng-if="item.status" ng-style="{'color': item.status.color }">{{ item.status.name }}</span>
						<span ng-if="!item.status">
									<span ng-if="item.proccess == 'edit'"> Düzenlendi</span>
									<span ng-if="item.proccess == 'rate'"> Puanlandı</span>
									<span ng-if="item.proccess == 'create'"> Oluşturuldu</span>
									<span ng-if="item.proccess == 'change_date'"> Tarihi Değiştirildi</span>
									<span ng-if="item.proccess == 'change_worker'"> Kargo Devredildi</span>
									<span ng-if="item.proccess == 'assign_worker'"> Created</span>
									<span ng-if="item.proccess == 'sending_sms'"> Sms Gönderildi</span>
									<span ng-if="item.proccess == 'call_record'"> Çağrı Kaydı</span>
									<span ng-if="item.proccess == 'waiting_start'"> Kargo Bekleme Durumuna Alındı</span>
									<span ng-if="item.proccess == 'waiting_end'"> Kargo Bekleme Durumundan Çıkarıldı</span>
									<span ng-if="item.proccess == 'change_order_fields'"> Özel Alan Değiştirildi</span>
									<span ng-if="item.proccess == '0'"> Created</span>
								</span>
					</td>
					<td>{{ item.reason }}</td>
					<td class="clickable-row" ng-click="getWorkerDetails(item.worker_id)">{{ item.worker.user.full_name }} </td>
					<td>{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>

				</tr>
				</tbody>
			</table>
			<dir-pagination-controls
					boundary-links="true"
					on-page-change="getPage(newPageNumber)"
					template-url="dirPagination.tpl.html"
					class="pagination-lg pagination">
				Toplam Kayıt {{data.notifications.total }}
			</dir-pagination-controls>

		</div>
		<div class="table-responsive" ng-if="data.notifications.data.length == 0">
			<div class="alert alert-default pastel">
				<i class="fa fa-info pr10"></i>
				<strong>
					Bildirim bulunamadı!
				</strong>
			</div>
		</div>
	</div>
</div>
